module.exports = __webpack_public_path__ + "img/IMG_9904.5eb9b606.jpeg";